define("shared/modifiers/circular-upload-animation", ["exports", "@ember/debug", "@ember/runloop", "ember-modifier", "progressbar.js"], function (_exports, _debug, _runloop, _emberModifier, _progressbar) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/runloop",0,"ember-modifier",0,"progressbar.js"eaimeta@70e063a35619d71f
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  var _removeUploadProgressAnimation = /*#__PURE__*/new WeakSet();
  /**
   * This handles the creation, animation, and destruction of
   * a circular progress bar, and allows for custom styling and colors to be passed in.
   *
   * Progress Bar Docs: https://progressbarjs.readthedocs.io/en/latest/
   *
   * Positional and Named parameters are outlined in the TypeScript interface above.
   *
   * Simple Usage:
   *
   * ```
   * <div class="cLB--imagePreview qa--upload_icon">
   *   <img
   *     class="cLB--imagePreview__img"
   *     src={{@thumbnail}}
   *     alt={{@title}}
   *   />
   *   <div
   *     class="e--upload-progress"
   *     {{circular-upload-animation @uploadProgress svgStyle=this.additionalSvgStyle color="#02ADFF"}}
   *   ></div>
   * </div>
   * ```
   */
  class CircularUploadAnimationModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      /**
       * Necessary to remove the svg after the upload is finished.
       * Docs: https://progressbarjs.readthedocs.io/en/latest/api/shape/#destroy
       */
      _classPrivateMethodInitSpec(this, _removeUploadProgressAnimation);
    }
    modify(element, _ref, _ref2) {
      let [uploadProgress] = _ref;
      let {
        svgStyle,
        color
      } = _ref2;
      (false && !(typeof uploadProgress === 'number') && (0, _debug.assert)(`positional arg must be 'number' but was ${typeof uploadProgress}`, typeof uploadProgress === 'number'));
      if (uploadProgress === 0) {
        return;
      }
      if (!this.loadingAnimation) {
        const animationSizeRatio = 5;
        const styling = {
          svgStyle: {
            ...svgStyle,
            position: 'absolute'
          },
          color,
          strokeWidth: animationSizeRatio,
          trailWidth: animationSizeRatio
        };
        const loadingAnimation = new _progressbar.default.Circle(element, styling);
        this.loadingAnimation = loadingAnimation;
      }
      this.loadingAnimation.animate(uploadProgress);
      (0, _runloop.scheduleOnce)('afterRender', this, _classPrivateMethodGet(this, _removeUploadProgressAnimation, _removeUploadProgressAnimation2));
    }
  }
  _exports.default = CircularUploadAnimationModifier;
  function _removeUploadProgressAnimation2() {
    (0, _runloop.later)(() => {
      this.loadingAnimation?.destroy();
      this.loadingAnimation = null;
    }, 2000);
  }
});